export default __webpack_public_path__ + "static/media/953.de119da0.gif";